/**
 * The tablet device type, for UA parsing.
 * @type {String}
 */
const DESKTOP_DEVICE = 'desktop';

/**
 * The tablet device type, for UA parsing.
 * @type {String}
 */
const TABLET_DEVICE = 'tablet';

/**
 * The mobile device type, for UA parsing.
 * @type {String}
 */
const MOBILE_DEVICE = 'mobile';

/**
 * The ios os name, for UA parsing.
 * @type {String}
 */
const IOS_OS_NAME = 'iOS';

/**
 * The android os name, for UA parsing.
 * @type {String}
 */
const ANDROID_OS_NAME = 'Android';

/**
 * A map of possible device type to it's reporting platform.
 * @type {Object<String>}
 */
const DEVICE_TO_PLATFORM_MAP = {
    MOBILE: MOBILE_DEVICE,
    TABLET: TABLET_DEVICE,
    DESKTOP: DESKTOP_DEVICE
};

module.exports = {
    MOBILE_DEVICE,
    TABLET_DEVICE,
    DESKTOP_DEVICE,
    IOS_OS_NAME,
    ANDROID_OS_NAME,
    DEVICE_TO_PLATFORM_MAP
};
